(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homare-booth-3d"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__homareBooth3DBootstrap) return;
  window.__homareBooth3DBootstrap = true;
  function loadBoothRuntime(scope) {
    const element = scope.querySelector('homare-booth-3d');
    if (!element || customElements.get('homare-booth-3d')) return;
    if (document.querySelector('script[data-homare-booth-runtime]')) return;
    const script = document.createElement('script');
    script.src = element.dataset.runtime;
    script.defer = true;
    script.dataset.homareBoothRuntime = 'true';
    script.onerror = () => {
      document.querySelectorAll('homare-booth-3d').forEach((host) => {
        host.setAttribute('aria-busy', 'false');
        const message = host.querySelector('.homare-booth-loading');
        if (message) message.textContent = '3Dシミュレーターを読み込めませんでした。ページを再読み込みしてください。';
      });
      script.remove();
    };
    document.head.appendChild(script);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => loadBoothRuntime(document), { once: true });
  } else {
    loadBoothRuntime(document);
  }
  document.addEventListener('shopify:section:load', (event) => loadBoothRuntime(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homare-floorea-3d"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__homareFloorea3DBootstrap) return;
  window.__homareFloorea3DBootstrap = true;
  function loadFlooreaRuntime(scope) {
    const element = scope.querySelector('homare-floorea-3d');
    if (!element || customElements.get('homare-floorea-3d')) return;
    if (document.querySelector('script[data-homare-floorea-runtime]')) return;
    const script = document.createElement('script');
    script.src = element.dataset.runtime;
    script.defer = true;
    script.dataset.homareFlooreaRuntime = 'true';
    script.onerror = () => {
      document.querySelectorAll('homare-floorea-3d').forEach((host) => {
        host.setAttribute('aria-busy', 'false');
        const message = host.querySelector('.homare-floorea-loading');
        if (message) message.textContent = '3Dシミュレーターを読み込めませんでした。ページを再読み込みしてください。';
      });
      script.remove();
    };
    document.head.appendChild(script);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => loadFlooreaRuntime(document), { once: true });
  } else {
    loadFlooreaRuntime(document);
  }
  document.addEventListener('shopify:section:load', (event) => loadFlooreaRuntime(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
